import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectTaskDefinitionList = state => {
    return selectOwnState(state).taskDefinitionList
}

export const selectTaskDefinitionById = (state, taskDefinitionId) => {
    const taskDefinitionList = selectTaskDefinitionList(state)
    for (let index = 0; index < taskDefinitionList.length; index++) {
        const taskDefinition = taskDefinitionList[index]
        if (taskDefinition.id === taskDefinitionId) {
            return taskDefinition
        }
    }
    return null
}



// WEBPACK FOOTER //
// ./src/modules/process/state/task-definition/selector.js